var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { useEffect, useRef, useState } from 'react';
import classNames from 'clsx';
import OutsideClickHandler from 'react-outside-click-handler';
import Button from '../button';
import Icon from '../icon';
import Popover from '../popover';
import Theme from '../theme.config';
import { Styled, StyledPopoverContent, FilterPanelStyled } from './style';
export var AdvancedFilterAction;
(function (AdvancedFilterAction) {
    AdvancedFilterAction["Add"] = "Add";
    AdvancedFilterAction["Remove"] = "Remove";
})(AdvancedFilterAction || (AdvancedFilterAction = {}));
export var AdvancedFilter = function (props) {
    var _a;
    var defaultActiveFilter = { title: 'recent', values: props.advancedFilter ? props.advancedFilter[0].values : [] };
    var _b = useState(false), mousedown = _b[0], setMousedown = _b[1];
    var _c = useState(''), keyword = _c[0], setKeyword = _c[1];
    var _d = useState(''), remainingKeyword = _d[0], setRemainingKeyword = _d[1];
    var _e = useState(false), filterOpen = _e[0], setFilterOpen = _e[1];
    var _f = useState(defaultActiveFilter), activeFilter = _f[0], setActiveFilter = _f[1];
    var inputRef = useRef(null);
    useEffect(function () {
        var advancedFilter = props.advancedFilter;
        var currentFilter = advancedFilter === null || advancedFilter === void 0 ? void 0 : advancedFilter.find(function (x) { return x.title === activeFilter.title; });
        if (activeFilter.values !== (currentFilter === null || currentFilter === void 0 ? void 0 : currentFilter.values)) {
            setActiveFilter({ title: activeFilter.title, values: currentFilter === null || currentFilter === void 0 ? void 0 : currentFilter.values });
        }
    }, props.advancedFilter);
    var applyValue = function (value) {
        var values = props.values, callback = props.callback;
        var isString = typeof value === 'string';
        var formatValue = {
            text: value,
            id: '',
        };
        var newValue = isString ? formatValue : value;
        callback({
            currentValue: newValue,
            values: __spreadArrays(values, [newValue]),
            value: newValue,
        }, AdvancedFilterAction.Add);
    };
    var onKeypress = function (event) {
        var values = props.values;
        if (event.key === 'Enter' && event.target.value !== '' && event.target.value.slice(event.target.value.length - 1) !== ':') {
            applyValue(event.target.value);
            setKeyword('');
        }
        else if (event.key === 'Backspace' && values.length > 0 && remainingKeyword.length === 0) {
            removeValue(values.length - 1);
        }
        setRemainingKeyword(event.target.value);
        return;
    };
    var onClick = function (event) {
        var advancedFilter = props.advancedFilter, recentFilter = props.recentFilter, onClick = props.onClick;
        if (advancedFilter && advancedFilter.length > 0 || recentFilter && recentFilter.length > 0) {
            setFilterOpen(true);
        }
        onClick && onClick(event);
    };
    var removeValue = function (index) {
        var _a;
        var values = props.values, callback = props.callback;
        (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        callback({ values: __spreadArrays(values.filter(function (item) { return values.indexOf(item) !== index; })) }, AdvancedFilterAction.Remove);
    };
    var removeValues = function () {
        var callback = props.callback;
        callback({ values: [] }, AdvancedFilterAction.Remove);
    };
    var onChange = function (event) {
        var onChange = props.onChange;
        setKeyword(event.target.value);
        onChange(event);
    };
    var onBlur = function (event) {
        var onBlur = props.onBlur;
        if (event.target.value !== '' && event.target.value.slice(event.target.value.length - 1) !== ':') {
            if (!mousedown) {
                applyValue(event.target.value);
                setKeyword('');
            }
        }
        else {
            if (!mousedown) {
                setKeyword('');
            }
        }
        setMousedown(false);
        onBlur && onBlur(event);
    };
    var handleFilterClick = function (event) {
        var _a, _b;
        var advancedFilter = props.advancedFilter, values = props.values;
        if (advancedFilter && advancedFilter.length > 0) {
            var currentFilter = advancedFilter.find(function (x) { return x.title === event.target.outerText; });
            var currentValues_1 = values.reduce(function (prev, current) { return __spreadArrays(prev, [current.text]); }, []);
            var sectionValues = (_a = currentFilter === null || currentFilter === void 0 ? void 0 : currentFilter.values) === null || _a === void 0 ? void 0 : _a.filter(function (x) { return !currentValues_1.includes(x.text); });
            setKeyword(event.target.outerText + ':');
            setActiveFilter({
                title: currentFilter ? currentFilter.title : '',
                values: sectionValues !== null && sectionValues !== void 0 ? sectionValues : [],
            });
            (_b = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
    };
    var handleOutsideClick = function () {
        var values = props.values, onOutsideClick = props.onOutsideClick;
        setActiveFilter(defaultActiveFilter);
        setMousedown(false);
        setFilterOpen(false);
        if (values.length > 0) {
            var lastIndex = (values === null || values === void 0 ? void 0 : values.length) - 1;
            var lastValue = {
                text: values[lastIndex].text,
                id: values[lastIndex].id,
            };
            onOutsideClick && onOutsideClick({
                currentValue: lastValue ? lastValue : [],
                values: __spreadArrays(values),
                value: lastValue ? lastValue : '',
            }, AdvancedFilterAction.Add);
        }
        else {
            onOutsideClick && onOutsideClick({});
        }
    };
    var handleAutoFill = function (value) {
        var _a;
        applyValue(value);
        setKeyword('');
        setRemainingKeyword('');
        (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    var handleMultipleAutoFill = function (values) {
        var callback = props.callback;
        var lastIndex = values.length - 1;
        var lastValue = {
            text: values[lastIndex].text,
            id: values[lastIndex].id,
        };
        callback({
            currentValue: lastValue,
            values: values,
            value: lastValue,
        }, AdvancedFilterAction.Add);
    };
    var autoFocus = props.autoFocus, currentValue = props.currentValue, disabled = props.disabled, values = props.values, warning = props.warning, advancedFilter = props.advancedFilter, open = props.open, placeholder = props.placeholder, recentFilter = props.recentFilter, loading = props.loading;
    return (React.createElement(OutsideClickHandler, { onOutsideClick: handleOutsideClick },
        React.createElement("div", { style: { position: 'relative' } },
            React.createElement(Styled, { className: classNames({
                    open: filterOpen, close: !filterOpen,
                    active: values.length > 0,
                }) },
                React.createElement("div", { className: "log-search-icon" },
                    React.createElement(Icon, { name: "search" })),
                values.map(function (item, index) { return (React.createElement("div", { key: index, className: "value" },
                    item.text,
                    React.createElement("i", { className: "close", onClick: function () { return removeValue(index); } }))); }),
                !currentValue || currentValue || keyword === '' || values.length === 0 ? (React.createElement("input", { type: "text", onKeyUp: function (event) { return onKeypress(event); }, placeholder: values.length === 0 ? placeholder || 'Press enter to add values' : '', autoFocus: autoFocus || values.length > 0, onChange: function (event) { return onChange(event); }, onClick: function (event) { return onClick(event); }, onBlur: function (event) { return onBlur(event); }, ref: inputRef, value: keyword, disabled: disabled })) : (React.createElement(Popover, { style: { marginTop: '-3px' }, trigger: React.createElement("input", { type: "text", value: keyword, onChange: function (event) { return onChange(event); }, onKeyUp: function (event) { return onKeypress(event); }, onBlur: function (event) { return onBlur(event); }, placeholder: placeholder, autoFocus: true }), content: React.createElement(StyledPopoverContent, null,
                        React.createElement(Icon, { name: "warning" }),
                        React.createElement("div", null, warning || 'Invalid Value.')), position: "bottom left", open: true })),
                values.length > 0 && React.createElement(Button, { icon: true, transparent: true, onClick: removeValues, className: "clear-tags" },
                    React.createElement(Icon, { className: "search-clear", name: "close" }))),
            React.createElement(FilterPanelStyled, { className: filterOpen || open ? 'open' : 'close' },
                advancedFilter && advancedFilter.length > 0 &&
                    React.createElement("div", null,
                        React.createElement("p", { className: "title" }, "Filter by:"),
                        advancedFilter.map(function (filter, id) { return (React.createElement("div", { key: id, className: "value", onClick: function (event) { return handleFilterClick(event); }, onMouseDown: function () { return setMousedown(true); } }, filter.title)); })),
                (activeFilter === null || activeFilter === void 0 ? void 0 : activeFilter.title) === 'recent' ? (React.createElement(React.Fragment, null, recentFilter && recentFilter.length > 0 &&
                    React.createElement("div", null,
                        React.createElement("p", { className: "title" },
                            React.createElement(Icon, { name: "clock", color: "" + Theme.color.base }),
                            "Recent searches"),
                        recentFilter.map(function (filter, idx) {
                            var _a;
                            return (React.createElement("div", { key: idx, className: "multi-value", onClick: function () { return handleMultipleAutoFill(filter.values); } }, (_a = filter.values) === null || _a === void 0 ? void 0 : _a.map(function (item, idx) { return (React.createElement("div", { key: idx, className: "value" }, item.text)); })));
                        })))) : (React.createElement("div", null,
                    React.createElement("p", { className: "title" }, activeFilter === null || activeFilter === void 0 ? void 0 : activeFilter.title),
                    loading ? (React.createElement("div", { className: "placeholder-loading" },
                        React.createElement("div", null),
                        React.createElement("div", null),
                        React.createElement("div", null))) : (React.createElement("div", { className: "tag-list" }, (_a = activeFilter === null || activeFilter === void 0 ? void 0 : activeFilter.values) === null || _a === void 0 ? void 0 : _a.map(function (item, idx) { return (React.createElement("span", { key: idx },
                        React.createElement("div", { className: "value", key: idx, onClick: function () { return handleAutoFill(item); }, onMouseDown: function () { return setMousedown(true); } }, item.text))); })))))))));
};
export default AdvancedFilter;
//# sourceMappingURL=index.js.map